import React from 'react';
import * as turf from '@turf/turf';
import { Icon } from 'leaflet';
import { FeatureGroup, Marker } from '@manifesto-tech/react-leaflet';
import defaultIcon from '../../images/marker-default.svg';
import Card from './Card.jsx';

const Markers = ({ markers }) => {
  return (
    <>
      {Object.keys(markers).length &&
        Object.keys(markers).map((markerType) => (
          <FeatureGroup key={markerType}>
            {markers[markerType].map((marker) => {
              const { coordinates, properties } = marker;
              const {
                type,
                image,
                name,
                description,
                linkText,
                linkUrl,
                icon: iconPath,
              } = properties;

              return (
                <>
                  {coordinates.map((position) => {
                    const pos = turf.getGeom(turf.point(position));

                    const icon = new Icon({
                      iconUrl: iconPath || defaultIcon,
                      iconSize: [40, 40],
                    });

                    return (
                      <Marker
                        key={turf.flip(pos).coordinates}
                        position={turf.flip(pos).coordinates}
                        icon={icon}
                      >
                        <Card
                          type={type}
                          name={name}
                          description={description}
                          linkText={linkText}
                          linkUrl={linkUrl}
                          image={image}
                          position={turf.flip(pos).coordinates}
                        />
                      </Marker>
                    );
                  })}
                </>
              );
            })}
          </FeatureGroup>
        ))}
    </>
  );
};

export default Markers;
